import Vue from "vue";
import App from "./App";
import { router } from "./router/routerMap.js";
import { initSensor } from "./countly.js";

//引入sfmui框架 （根据项目实际使用引入对应的组件）
import "sfmui/dist/css/sfmui.min.css";
import "./comm/font/font.less";
// 全局公共组件引入
import "./components"

import {
  Icon,
  Toast,
  Navbar,
  ScrollerY,
  Spinner,
  Divider,
  Popup,
  Switch,
  Group,
  PopupPicker,
  Input,
  Textarea,
  Datetime,
  Address,
  Grid,
  GridItem,
  Picker,
  Button,
  Checklist,
  Checker,
  CheckerItem,
  Radio,
  Carousel,
  CarouselItem
} from "sfmui";
Vue.component(Icon.name, Icon);
Vue.component(Navbar.name, Navbar);
Vue.component(Spinner.name, Spinner);
Vue.component(Divider.name, Divider);
Vue.component(Popup.name, Popup);
Vue.component(Switch.name, Switch);
Vue.component(Group.name, Group);
Vue.component(PopupPicker.name, PopupPicker);
Vue.component(Input.name, Input);
Vue.component(Datetime.name, Datetime);
Vue.component(Address.name, Address);
Vue.component(Textarea.name, Textarea);
Vue.component(Grid.name, Grid);
Vue.component(GridItem.name, GridItem);
Vue.component(Picker.name, Picker);
Vue.component(Button.name, Button);
Vue.component(Checklist.name, Checklist);
Vue.component(Checker.name, Checker);
Vue.component(CheckerItem.name, CheckerItem);
Vue.component(Radio.name, Radio);
Vue.component(Carousel.name, Carousel);
Vue.component(CarouselItem.name, CarouselItem);
// Vue.component(Previewer.name, Previewer)

import { Loading, Modal } from "sfmui";
Vue.use(Loading);
Vue.use(Toast);
Vue.use(ScrollerY);
Vue.use(Modal);

import { TransferDom } from "sfmui";
Vue.directive("TransferDom", TransferDom);

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

import VueAxiosExt from "./comm/js/axiosExt.vue.plugin";
Vue.use(VueAxiosExt);

import VueClipboards from "vue-clipboard2";
Vue.use(VueClipboards);

import {
  Sticky,
  Search,
  Icon as VantIcon,
  Uploader,
  Cascader,
  Field,
  List,
  Dialog,
  Picker as PickerVant,
  Popup as Popups,
  ImagePreview,
  ActionSheet,
  Progress,
  Empty,
  DatetimePicker,
  Loading as VantLoading
} from "vant";
Vue.component(Cascader.name, Cascader);
Vue.component(Field.name, Field);
Vue.use(Popups);
Vue.use(Sticky);
Vue.use(Search);
Vue.use(VantIcon);
Vue.use(Uploader);
Vue.use(List);
Vue.use(ActionSheet);
Vue.use(VantLoading);
Vue.use(Dialog);
Vue.use(Progress);
Vue.use(PickerVant);
Vue.use(ImagePreview);
Vue.use(Empty)
Vue.use(DatetimePicker)

import 'vant/lib/index.css';

import wcView from "wc-view";
import "wc-view/style.css";
Vue.use(wcView);

import vueCompositionApi from "@vue/composition-api";
Vue.use(vueCompositionApi);

import "@/comm/js/request.js";

import "./comm/font/iconfont.css";
import "./comm/css/global.less";
import "./comm/css/resume.less";
import "./comm/css/animate.css";
import "./comm/css/vantCom.less";
import "@/assets/font/fonts.css";

// 前端监控
import "@/comm/js/apm.js";
window.processEnvNodeEnv = process.env.NODE_ENV;

//引入项目中公共的样式和js
//import './comm/css/X.less'
//import './comm/js/X.js'

/**
 * 引入适配js文件
 */
// import './comm/js/flexible.js'
import "lib-flexible";

/**
 * 公共方法
 */
import commMethods from "./comm/js/methods.vue.plugin.js";
Vue.use(commMethods);

// 引入window._global
Vue.prototype.$global = window._global;
/**
 * 测试需要调试时开启
 */
if (window._global && window._global._ENV === "sit") {
  var { VConsole } = require("./comm/js/vconsole.min.js");
  new VConsole();
}
let u = navigator.userAgent;
let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器

if (isAndroid) {
  store.state.global.isAndroid = true;
} else {
  store.state.global.isAndroid = false;
  //ios
}
Vue.config.productionTip = false;

import store from "./store";

/**
 * 初始化Vue
 */
window.showHeader = false;
new Vue({
  store,
  router,
  el: "#app",
  template: "<App/>",
  components: {
    App
  }
});

// 默认不传工号，因为存在游客身份（登录页等未登录场景也需要埋点）
// 登录成功后 App.vue 会用真实工号重新初始化，绑定 distinctId
initSensor("");



// WEBPACK FOOTER //
// ./src/main.js